<template>
  <div class="airDetails" v-loading="loading">
    <chang-refund :detailData="detailData" v-if="detailData" @getData="getData"></chang-refund>
    <div class="flex-center">
      <el-button type="primary" size="small" @click="submit" :disabled="!formData">提交</el-button>
      <el-button type="" size="small" @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>
<script>
// 订单查询
// const detail = require(`@/lib/data-service/flight/flight_domestic_buyer_manage_order_detail`);
import ChangeDetail from "@/lib/data-service/flight/newFligthApi/buyer_dom_manage_change";

const change = require(`@/lib/data-service/flight/flight_domestic_buyer_white_order_change`);
import ChangRefund from "./components/changRefund";

export default {
  data() {
    return {
      loading: true,
      detailData: null,
      orderNo: "",
      orderStatus: "",
      beginDate: "",
      orderStatusText: "",
      flightType: "1",
      passengers: [],
      changeType: 1,
      dishonourId: [],
      cabinCode: "",
      remark: "",
      formData: null,
      dialogVisible: false,
      payType: null
    };
  },
  components: { ChangRefund },
  methods: {
    GetdetailData() {
      let _this = this;
      ChangeDetail({ orderNo: this.orderNo })
        .then(res => {
          this.loading = false;
          res.changeRes.passengerList.map(item => {
            setNewDate(item);
          });
          this.detailData = res.changeRes;
        })
        .catch(() => {
          this.loading = false;
          this.$router.go(-1);
        });
      function setNewDate(list) {
        list.changeSegmentList.map(item => {
          item.startTime = _this.$moment(
            item.beginDate + " " + item.beginTime
          )._d;
        });
      }
    },
    getsegments(id, inputType) {
      inputType.inputC = !inputType.inputC;
      console.log(id, inputType);
    },
    getData(val) {
      this.formData = val;
    },
    submit() {
      let data = JSON.parse(JSON.stringify(this.formData));
      if (!data.segmentList.length)
        return this.$message({ type: "warning", message: "请选择改签航班" });

      let _this = this;
      if (this.$route.query.psgType == 1) {
        data.segmentList = getSegmentList(data.segmentList);
        if (data.chaReason == 2) {
          if (!data.url)
            return this.$message({
              type: "warning",
              message: "请上传延误证明！"
            });
        }
      } else if (this.$route.query.psgType == 2) {
        if (data.chaReason == 2) {
          if (!data.url)
            return this.$message({
              type: "warning",
              message: "请上传延误证明！"
            });
        }
      } else {
        if (!data.remark)
          return this.$message({ type: "warning", message: "请输入备注！" });
        for (let index = 0; index < data.segmentList.length; index++) {
          if (!data.segmentList[index].aduTicketNumber)
            return this.$message({
              type: "warning",
              message: "请输入成人票号！"
            });
        }
        let list = data.segmentList.map(sItem => {
          let time = this.$moment(sItem.startTime)
            .format("YYYY-MM-DD HH:mm:ss")
            .split(" ");
          let Obj = {
            cabinCode: sItem.cabinCode,
            depDate: time[0],
            depTime: time[1],
            arrDate: sItem.arriveDate,
            arrTime: sItem.arriveTime,
            flightNo: sItem.flightNo,
            segmentNo: sItem.segmentNo
          };
          return Obj;
        });
        data.adultTicketNo = data.segmentList.map(item => {
          return item.aduTicketNumber;
        });
        data.adultTicketNo = data.adultTicketNo.join(",");
        data.segmentList = list;
        // if (data.segmentList.length == 0) {
        //   //手工单不选
        //   let passengerNoList = this.detailData.passengerList.map(item => {
        //     return item.psgNo;
        //   });
        //   let segmentList = [];
        //   this.detailData.passengerList.map(item => {
        //     let list = item.changeSegmentList.map(sItem => {
        //       let Obj = {
        //         cabinCode: sItem.cabinCode,
        //         depDate: sItem.beginDate,
        //         depTime: sItem.beginTime,
        //         flightNo: sItem.flightNo,
        //         segmentNo: sItem.segmentNo
        //       };
        //       return Obj;
        //     });
        //     segmentList.push(...list);
        //   });
        //   console.log(segmentList, passengerNoList);
        //   data.passengerNoList = passengerNoList;
        //   data.segmentList = segmentList;
        // } else {
        // }
      }
      console.log(data);
      this.loading = true;
      change(data).then(res => {
        this.loading = false;
        if (res.code == this.SUCCESS_CODE) {
          this.$router.push({
            name: "air-ticket-admin-change-order-list",
            params: { refresh: 1 }
          });
          this.$message({ type: "success", message: "改签成功！" });
        }
      });
      function getSegmentList(val) {
        let segmentList = val.map(item => {
          let date = _this
            .$moment(item.startTime)
            .format("YYYY-MM-DD HH:mm:ss");
          date = date.split(" ");
          let list = {
            cabinCode: item.cabinCode,
            depDate: date[0],
            depTime: date[1],
            flightNo: item.flightNo,
            segmentNo: item.segmentNo
          };
          return list;
        });
        return segmentList;
      }
    },

    getDishonour() {
      console.log(this.passengers);
      if (this.changeType === "请选择") {
        return this.$message({
          message: "请选择退票类型",
          type: "error"
        });
      }
      if (this.changeType === 1 && this.beginDate === "") {
        return this.$message({
          message: "请填写改签日期",
          type: "error"
        });
      }
      if (this.changeType === 2 && this.cabinCode === "") {
        return this.$message({
          message: "请填写改签舱位",
          type: "error"
        });
      }
      this.dishonourId = [];
      for (let i = 0; i < this.passengers.length; i++) {
        for (let j = 0; j < this.passengers[i].segments.length; j++) {
          if (this.passengers[i].segments[j].inputC === true) {
            this.dishonourId.push(this.passengers[i].segments[j].airlineId);
          }
        }
      }
      if (this.dishonourId.length === 0) {
        return this.$message({
          message: "请选择需要改签的乘客",
          type: "error"
        });
      }
      let lineId = this.dishonourId.join();
      console.log(this.dishonourId);
      let params = {
        changes: [
          {
            beginDate: this.beginDate,
            cabinCode: this.cabinCode,
            changeType: this.changeType,
            segmentIds: lineId
          }
        ],
        remark: this.remark,
        orderNo: this.orderNo
      };
      console.log(params);
      change(params)
        .then(res => {
          console.log(res);
          this.$router.go(-1);
        })
        .catch(err => {
          return this.$message({
            message: err,
            type: "error"
          });
        });
    }
  },
  activated() {
    this.orderNo = this.$route.query.ordersNo;
    // this.orderStatus = this.$route.query.orderStatus;
    // this.orderStatusText = this.$route.query.orderStatusText;
    this.GetdetailData();
    // detail({ orderNo: this.orderNo }).then(res => {
    //   this.detailData = res.detail;
    //   this.flightType = res.detail.flightType;
    //   this.passengers = res.detail.passengers;
    //   for (let i = 0; i < this.passengers.length; i++) {
    //     for (let j = 0; j < this.passengers[i].segments.length; j++) {
    //       this.passengers[i].segments[j].inputC = false;
    //     }
    //   }
    //   this.$forceUpdate();
    // });
  }
};
</script>
<style scoped lang="less">
.airDetails {
  width: 100%;
}
</style>
